<div class="card-header">
  <app-breadcrumb currentPage="e-mailadres is aangepast"></app-breadcrumb>
</div>

<div class="card-body">
  <p> Uw e-mailadres is aangepast. U kunt nu aan de slag met Reveon door in
    te loggen met het nieuwe e-mailadres en het eerder door u gekozen wachtwoord.</p>
  <div class="spacer"></div>
  <button class="btn user" routerLink="/login">inloggen</button>
</div>
